<template>
  <b-modal
    :visible="visible"
    :title="$t('prontuariosPage.patientModal.title')"
    size="lg"
    no-close-on-backdrop
    no-close-on-esc
    hide-header-close
    :ok-title="$t('prontuariosPage.patientModal.confirm')"
    :cancel-title="$t('prontuariosPage.patientModal.cancel')"
    :ok-disabled="!draftPatient"
    @ok.prevent="onConfirm"
    @hide="$emit('update:visible', false)"
  >
    <p class="text-muted mb-3">{{ $t("prontuariosPage.patientModal.help") }}</p>

    <div v-if="loading" class="text-center py-3">
      <b-spinner small class="mr-2" />
      {{ $t("prontuariosPage.patientModal.loading") }}
    </div>

    <div v-else>
      <label class="form-label" for="medical-records-patient-select">
        {{ $t("prontuariosPage.patientModal.label") }}
      </label>
      <multiselect
        id="medical-records-patient-select"
        v-model="draftPatient"
        :options="patientOptions"
        :placeholder="$t('prontuariosPage.patientModal.placeholder')"
        label="label"
        track-by="id"
        :multiple="false"
        :allow-empty="true"
        :show-labels="false"
        class="medical-records-patient-multiselect"
        :select-label="$t('prontuariosPage.patientModal.selectLabel')"
        :deselect-label="$t('prontuariosPage.patientModal.deselectLabel')"
        :selected-label="$t('prontuariosPage.patientModal.selectedLabel')"
      >
        <template #option="props">
          <span>{{ props.option.id }} — {{ props.option.name }}</span>
        </template>
        <template #singleLabel="{ option }">
          <span v-if="option">{{ option.id }} — {{ option.name }}</span>
        </template>
        <template #noResult>
          {{ $t("prontuariosPage.patientModal.noResults") }}
        </template>
      </multiselect>
    </div>
  </b-modal>
</template>

<script>
import Multiselect from "vue-multiselect";

export default {
  name: "MedicalRecordsPatientSelectModal",
  components: { Multiselect },
  props: {
    visible: {
      type: Boolean,
      default: false,
    },
    patientOptions: {
      type: Array,
      default: () => [],
    },
    loading: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      draftPatient: null,
    };
  },
  watch: {
    visible(open) {
      if (open) {
        this.draftPatient = null;
      }
    },
  },
  methods: {
    onConfirm() {
      if (!this.draftPatient) {
        return;
      }
      this.$emit("confirm", this.draftPatient);
      this.$emit("update:visible", false);
    },
  },
};
</script>
